// 日期顯示：API 回的是 ISO 字串，一律讀 UTC 值直接顯示（CLAUDE.md 時區規範）。
// 檔期欄位（flight_start / flight_end）存的是台北日的 UTC 00:00，所以讀 UTC 就是正確的日期。
// 原本住在 pages/campaignReview/summary.ts，那頁移除後搬來這裡共用。

/** ISO → YYYY-MM-DD（讀 UTC，不受瀏覽器時區影響） */
export function ymd(iso: string | null): string {
  if (!iso) return '未設定'
  const d = new Date(iso)
  return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}-${String(
    d.getUTCDate(),
  ).padStart(2, '0')}`
}

/** ISO → YYYY-MM-DD HH:MM（讀 UTC） */
export function formatDateTime(iso: string | null): string {
  if (!iso) return '無'
  const d = new Date(iso)
  return `${ymd(iso)} ${String(d.getUTCHours()).padStart(2, '0')}:${String(d.getUTCMinutes()).padStart(2, '0')}`
}
